"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PointsOrDealLabel = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _internal = require("../../hooks/internal");
var _internal2 = require("../../utils/internal");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PointsOrDealLabel = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    code,
    labels,
    points
  } = (0, _internal.useProduct)();
  const {
    background,
    currency,
    productPoints,
    userPoints
  } = points ?? {};
  if (productPoints != null && currency == null) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PointsAndLabelsWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Points, {
        background: (0, _internal2.getPointsBackground)({
          background,
          productPoints,
          userPoints
        }),
        "data-testid": `${getTestId('points')}-${code}`,
        children: productPoints
      })
    });
  }
  const {
    labelKey = null,
    title = null
  } = labels?.deal ?? {};
  if ((0, _presentationComponents.isDealLabel)(labelKey) && title) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PointsAndLabelsWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Deal, {
        label: title,
        type: labelKey,
        productCode: code
      })
    });
  }
  return null;
};
exports.PointsOrDealLabel = PointsOrDealLabel;
